import React from "react";
import PropTypes from "prop-types";
import { Box, Paper, Typography, Grid, TextField } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";

const patientFieldSx = {
  "&& .MuiInputLabel-root": {
    fontSize: "1rem !important",
    fontWeight: "600 !important",
  },
  "&& .MuiInput-underline.Mui-focused": {
    borderColor: "#7c3aed !important",
    boxShadow: "0 0 0 3px rgba(124, 58, 237, 0.1) !important",
  },
};

const PatientInfoCard = ({
  t,
  prescriptionAssign,
  patientFirstName,
  patientLastName,
  patientEmail,
  patientPhone,
  patientDOB,
  patientRecord,
  searchedItems,
  onPatientEmailChange,
  onPatientPhoneChange,
  patientEmailError,
  patientPhoneError,
}) => {
  const resolvedDOB =
    patientDOB ||
    (searchedItems &&
      (searchedItems.dateOfBirth ||
        searchedItems.DateOfBirth ||
        searchedItems.dob_str ||
        searchedItems.DOB)) ||
    "";

  const resolvedPatientRecord =
    patientRecord ||
    (searchedItems &&
      (searchedItems.PatientRecordNumber ||
        searchedItems.patientRecordNumber ||
        searchedItems.patient_record_number ||
        searchedItems.PatientID ||
        searchedItems.patientID)) ||
    "";

  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        mb: 3,
        background: "#ffffff",
        border: "1px solid #e2e8f0",
        borderRadius: 3,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 3,
          pb: 2,
          borderBottom: "2px solid #f1f5f9",
        }}
      >
        <PersonIcon
          sx={{
            color: "#7c3aed",
            fontSize: 28,
            mr: 1.5,
          }}
        />
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            fontSize: "1.1rem",
            color: "#1e293b",
            letterSpacing: "0.01em",
          }}
        >
          {t("Home.StartConsultPopup.PatientDetails")}
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <TextField
            fullWidth
            label={t("Assign.FirstName") || "First Name"}
            value={patientFirstName}
            variant="standard"
            margin="normal"
            disabled={!prescriptionAssign}
            InputLabelProps={{ shrink: true }}
            sx={patientFieldSx}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            fullWidth
            label={t("Assign.LastName") || "Last Name"}
            value={patientLastName}
            variant="standard"
            margin="normal"
            disabled={!prescriptionAssign}
            InputLabelProps={{ shrink: true }}
            sx={patientFieldSx}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            fullWidth
            label={t("Assign.Email") || "Email"}
            value={patientEmail}
            variant="standard"
            margin="normal"
            disabled={!prescriptionAssign}
            InputLabelProps={{ shrink: true }}
            error={Boolean(patientEmailError)}
            helperText={patientEmailError}
            sx={patientFieldSx}
            onChange={(e) =>
              onPatientEmailChange && onPatientEmailChange(e.target.value)
            }
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            fullWidth
            label={t("Assign.SMSPhone") || "SMS Phone"}
            value={patientPhone}
            variant="standard"
            margin="normal"
            disabled={!prescriptionAssign}
            InputLabelProps={{ shrink: true }}
            error={Boolean(patientPhoneError)}
            helperText={patientPhoneError}
            sx={patientFieldSx}
            onChange={(e) =>
              onPatientPhoneChange && onPatientPhoneChange(e.target.value)
            }
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            fullWidth
            label={t("Assign.DOB") || "D.O.B"}
            value={resolvedDOB}
            variant="standard"
            margin="normal"
            disabled={!prescriptionAssign}
            InputLabelProps={{ shrink: true }}
            sx={patientFieldSx}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            fullWidth
            label={t("Assign.PatientRecordNumber")}
            value={resolvedPatientRecord}
            variant="standard"
            margin="normal"
            disabled={!prescriptionAssign}
            InputLabelProps={{ shrink: true }}
            sx={patientFieldSx}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

PatientInfoCard.propTypes = {
  t: PropTypes.func.isRequired,
  prescriptionAssign: PropTypes.bool,
  patientFirstName: PropTypes.string,
  patientLastName: PropTypes.string,
  patientEmail: PropTypes.string,
  patientPhone: PropTypes.string,
  patientDOB: PropTypes.string,
  patientRecord: PropTypes.string,
  searchedItems: PropTypes.object,
  onPatientEmailChange: PropTypes.func,
  onPatientPhoneChange: PropTypes.func,
  patientEmailError: PropTypes.string,
  patientPhoneError: PropTypes.string,
};

PatientInfoCard.defaultProps = {
  prescriptionAssign: true,
  patientFirstName: "",
  patientLastName: "",
  patientEmail: "",
  patientPhone: "",
  patientDOB: "",
  patientRecord: "",
  searchedItems: {},
  onPatientEmailChange: undefined,
  onPatientPhoneChange: undefined,
  patientEmailError: "",
  patientPhoneError: "",
};

export default PatientInfoCard;



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/counter/components/PatientInfoCard.jsx